import supabase from "@/features/supabase";
import { AuthSession } from "@supabase/supabase-js";
import { jwtDecode } from "jwt-decode";

export const decodeSessionJwt = (session: AuthSession | null) => {
  if (!session) return null;
  return jwtDecode(session.access_token) as AuthSession["user"];
};

const getCurrentSession = async (): Promise<AuthSession | null> => {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session) return null;
  return data.session;
};

const isRole = async (role: string): Promise<boolean> => {
  const session = await getCurrentSession();
  const decoded = decodeSessionJwt(session);
  if (!decoded) return false;

  return decoded?.user_metadata["role"]?.includes(role) ?? false;
};

export const verifyIsOwner = (): Promise<boolean> => isRole("owner");
